import { render, staticRenderFns } from "./SelectRoleDialog.vue?vue&type=template&id=bca78014&"
import script from "./SelectRoleDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectRoleDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports